export { abstractEntityService } from './abstract-entity-service';
